import React, { PropsWithChildren } from 'react'
import Link from 'next/link'

import { StyledButton, StyledLink } from './styles'

type Props = {
  size?: string
  isDisabled?: boolean
  isDark?: boolean
  href?: string
  as?: string
  onClick?: () => void
  type?: 'button' | 'submit'
  backgroundColor?: string
  className?: string
}

export const RectButton: React.FC<PropsWithChildren<Props>> = ({
  children,
  size = '24px',
  isDisabled,
  isDark,
  href,
  onClick,
  type = 'button',
  as,
  className,
}) => {
  if (href) {
    return (
      <Link href={href} as={as} passHref legacyBehavior>
        <StyledLink isDark={isDark} isDisabled={isDisabled} size={size} className={className}>
          {children}
        </StyledLink>
      </Link>
    )
  }

  return (
    <StyledButton
      isDark={isDark}
      isDisabled={isDisabled}
      size={size}
      onClick={onClick}
      type={type}
      disabled={isDisabled}
      className={className}
    >
      {children}
    </StyledButton>
  )
}
